module.exports = __webpack_public_path__ + "img/logo-viva-dark.9f461501.png";